import { useAuth } from "@/contexts/AuthContext";
import GoalsPanel from "@/components/GoalsPanel";
import MenuSheet from "@/components/MenuSheet";
import { CalendarDays } from "lucide-react";

export default function Sidebar({ currentDate }) {
  const { user } = useAuth();

  return (
    <aside
      className="lg:col-span-5 order-2 lg:order-1 flex flex-col gap-6 lg:sticky lg:top-6 lg:h-[calc(100vh-3rem)]"
      data-testid="sidebar"
    >
      <div className="hidden lg:flex items-center gap-2">
        <MenuSheet />
        <div className="flex items-center gap-2 text-primary flex-1">
          <CalendarDays strokeWidth={1.5} className="size-7" />
          <span className="font-display font-extrabold text-2xl tracking-tight text-foreground">
            Lumivera
          </span>
        </div>
        <span className="text-xs text-muted-foreground truncate max-w-[110px]" title={user?.email}>
          {user?.name}
        </span>
      </div>

      {/* Goals — first and most prominent */}
      <div className="rounded-2xl border-2 border-primary/30 bg-card p-5 shadow-sm flex-1 overflow-y-auto">
        <GoalsPanel currentDate={currentDate} />
      </div>
    </aside>
  );
}
